var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.5,
    fill: "white",
    stroke: "#44814E",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 75C46.5417 75 43.2917 74.3438 40.25 73.0312C37.2083 71.7188 34.5625 69.9375 32.3125 67.6875C30.0625 65.4375 28.2812 62.7917 26.9688 59.75C25.6562 56.7083 25 53.4583 25 50C25 46.5417 25.6562 43.2917 26.9688 40.25C28.2812 37.2083 30.0625 34.5625 32.3125 32.3125C34.5625 30.0625 37.2083 28.2812 40.25 26.9688C43.2917 25.6562 46.5417 25 50 25C53.4583 25 56.7083 25.6562 59.75 26.9688C62.7917 28.2812 65.4375 30.0625 67.6875 32.3125C69.9375 34.5625 71.7188 37.2083 73.0312 40.25C74.3438 43.2917 75 46.5417 75 50C75 53.4583 74.3438 56.7083 73.0312 59.75C71.7188 62.7917 69.9375 65.4375 67.6875 67.6875C65.4375 69.9375 62.7917 71.7188 59.75 73.0312C56.7083 74.3438 53.4583 75 50 75ZM35.8125 64.1875L50 50V30C44.4167 30 39.6875 31.9375 35.8125 35.8125C31.9375 39.6875 30 44.4167 30 50C30 52.6667 30.5 55.2292 31.5 57.6875C32.5 60.1458 33.9375 62.3125 35.8125 64.1875Z",
    fill: "#44814E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.e64380afab804b58341c4351fd689308.svg";
export { ForwardRef as ReactComponent };